import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "login" */ '@/views/Login.vue'),
      needAuth: false,
    },
    {
      path: '/positions',
      name: 'positions',
      component: () => import(/* webpackChunkName: "positions" */ '@/views/Positions.vue'),
      needAuth: true
    },
    {
      path: '/persons',
      name: 'persons',
      component: () => import(/* webpackChunkName: "persons" */ '@/views/Persons.vue'),
      needAuth: true
    },
    {
      path: '/classheads',
      name: 'classheads',
      component: () => import(/* webpackChunkName: "classheads" */ '@/views/Classheads.vue'),
      needAuth: true
    },
    {
      path: '/uberclassheads',
      name: 'uberclassheads',
      component: () => import(/* webpackChunkName: "uberclassheads" */ '@/views/UberClassheads.vue'),
      needAuth: true
    },
    {
      path: '/guests',
      name: 'guests',
      component: () => import(/* webpackChunkName: "guests" */ '@/views/Guests.vue'),
      needAuth: true
    },
    {
      path: '/passages',
      name: 'passages',
      component: () => import(/* webpackChunkName: "person" */ '@/views/Passages.vue'),
      props: true,
      needAuth: true
    },
  ]
})
